import { UserProvider } from "src/hooks/useUser";
import Header from "./Header";
import { PrintClient } from "src/types";
import PersonTable from "../IncomeTable/PersonTable";

interface PrintProps {
  client: PrintClient;
  scenario: any;
}

const ByPerson = ({ client, scenario }: PrintProps) => {
  return (
    <UserProvider ignoreLogin>
      <Header client={client} scenario={scenario} page="Income By Person" />
      <div className="mx-auto px-10">
        <div>
          <PersonTable
            print
            client={client}
            scenario={scenario}
            selectedYear={0}
            setSelectedYear={() => { }}
            selectedColumn={{ id: 0, type: "none" }}
            setSelectedColumn={() => { }}
          />
        </div>
      </div>
    </UserProvider>
  );
};

export default ByPerson;
